const CACHE = {
  GLOBAL_SECTION_DETAILS_CACHE: 'globalSectionDetailsCache',
  GLOBAL_SECTION_ORDERS_CACHE: 'globalSectionOrdersCache',
  GLOBAL_DATA_SOURCE_SECTIONS_CACHE: 'globalDataSourceSectionsCache',
  GLOBAL_DATA_SOURCE_SELECTIONS_CACHE: 'globalDataSourceSelectionsCache',
  GLOBAL_VERIFICATION_RESULT_LAYOUT_CACHE: 'globalVerificationResultLayoutCache',
  GLOBAL_VERIFICATION_FORM_ORDERS_CACHE: 'globalVerificationFormOrdersCache',
};

export default CACHE;